import Downtown1 from '../Downtown/Downtown (1).webp'
import Downtown2 from '../Downtown/Downtown (2).webp'
import Downtown3 from '../Downtown/Downtown (3).webp'
import Downtown4 from '../Downtown/Downtown (4).webp'
import Downtown5 from '../Downtown/Downtown (5).webp'
import Downtown6 from '../Downtown/Downtown (6).webp'
import Downtown7 from '../Downtown/Downtown (7).webp'

const Downtownimages =[
Downtown1,Downtown2,Downtown3,Downtown4,Downtown5,Downtown6,Downtown7
]

export default Downtownimages;